import { render } from "./Search.vue?vue&type=template&id=5fa4062a&scoped=true&ts=true"
import script from "./Search.ts?vue&type=script&lang=ts"
export * from "./Search.ts?vue&type=script&lang=ts"

import "./Search.scss?vue&type=style&index=0&id=5fa4062a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa4062a"]])

export default __exports__